import { FC, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { fetchlatestcategorisedProducts} from "../redux"

interface ProductType {
    id: number;
    name: string;
    category: {
      name: string;
    };
    supplier: {
      name: string;
    };
    quantity: number;
    buying_price: number;
    selling_price: number;
    offer_status: string;
    volume: number;
    image_url: string;
    updated_at: string;
  }

 interface PromoType {
  fetchlatestcategorisedProducts: any;
  category_id: number;
  name: string;
 }
  

const PromoProducts: FC<PromoType> = ({fetchlatestcategorisedProducts, category_id, name }) => {

  const [products, setProducts] = useState<ProductType[]>([]);

  useEffect(() => {
    const handleAsync = async () => {
        fetchlatestcategorisedProducts(category_id, (res: any) => {
        const { data, status } = res;
        if (status === "info") {
            setProducts(data);
          }
      });
    };
    handleAsync();
    // eslint-disable-next-line
  }, []);

  return (
    <>
    <section>
  <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 lg:items-stretch">
      <div className="flex items-center p-8 bg-gray-100 rounded">
        <div className="mx-auto text-center lg:text-left">
          <h2 className="text-2xl font-bold">
            {name}
          </h2>
          <p className="mt-4 text-sm text-gray-700 max-w-[45ch]">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, cupiditate mollitia saepe vitae libero nobis.
          </p>
          <a href="/collections/watches" className="inline-block px-6 py-3 mt-6 text-sm text-white bg-black rounded">
            View the Range
          </a>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 lg:col-span-2 lg:grid-cols-3 lg:py-12">
      {products.map((product: ProductType, i: number) => (

        
<Link to={`/product/view/${product.id}`} className="block" key={i}>
          <div className="aspect-w-1 aspect-h-1">
            <img   alt={product.name} className="object-cover rounded"  src={product.image_url} />
          </div>
          <div className="pt-3 flex items-center justify-between">
<p>{product && product.name}</p>
<svg
  className="h-6 w-6 fill-current text-gray-500 hover:text-black"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <path d="M12,4.595c-1.104-1.006-2.512-1.558-3.996-1.558c-1.578,0-3.072,0.623-4.213,1.758c-2.353,2.363-2.352,6.059,0.002,8.412 l7.332,7.332c0.17,0.299,0.498,0.492,0.875,0.492c0.322,0,0.609-0.163,0.792-0.409l7.415-7.415 c2.354-2.354,2.354-6.049-0.002-8.416c-1.137-1.131-2.631-1.754-4.209-1.754C14.513,3.037,13.104,3.589,12,4.595z M18.791,6.205 c1.563,1.571,1.564,4.025,0.002,5.588L12,18.586l-6.793-6.793C3.645,10.23,3.646,7.776,5.205,6.209 c0.76-0.756,1.754-1.172,2.799-1.172s2.035,0.416,2.789,1.17l0.5,0.5c0.391,0.391,1.023,0.391,1.414,0l0.5-0.5 C14.719,4.698,17.281,4.702,18.791,6.205z" />
</svg>
</div>
<p className="mt-1 text-sm text-gray-700">
{`Ksh. ${
                            product && product.selling_price
                          }`}
            </p>
        </Link>

      ))}

      </div>
    </div>
  </div>
</section>
    </>
  )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        fetchlatestcategorisedProducts: (category_id: number, callbackfunction: any) =>
        dispatch(fetchlatestcategorisedProducts(category_id, callbackfunction))
    };
  };
  
  export default connect(null, mapDispatchToProps)(PromoProducts);
  